import { render, staticRenderFns } from "./NatureTravaux.vue?vue&type=template&id=253747ae"
import script from "./NatureTravaux.vue?vue&type=script&lang=js"
export * from "./NatureTravaux.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports